import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface PortfolioProject {
  id: string;
  title: string;
  description: string;
  url: string;
  category: string;
  image_url: string | null;
  video_url: string | null;
  display_order: number;
  is_featured: boolean;
  is_active: boolean;
}

interface UsePortfolioProjectsOptions {
  featuredOnly?: boolean;
  limit?: number;
}

export function usePortfolioProjects(options: UsePortfolioProjectsOptions = {}) {
  const [projects, setProjects] = useState<PortfolioProject[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      setError(null);
      
      try {
        let query = supabase
          .from("portfolio_projects")
          .select("*")
          .eq("is_active", true)
          .order("display_order", { ascending: true });

        if (options.featuredOnly) {
          query = query.eq("is_featured", true);
        }

        if (options.limit) {
          query = query.limit(options.limit);
        }

        const { data, error: queryError } = await query;

        if (queryError) {
          throw queryError;
        }

        setProjects(data || []);
      } catch (err) {
        console.error("Error fetching portfolio projects:", err);
        setError(err instanceof Error ? err.message : "Failed to load projects");
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [options.featuredOnly, options.limit]);

  return { projects, loading, error };
}
